import { createContext, useContext } from 'react';
import type { MarketDef, PublicTenant, Trader } from '@ck/sdk';

export interface Portal {
  tenant: PublicTenant;
  trader: Trader;
  market: MarketDef;
  page: string;
  go: (page: string, market?: string) => void;
  refreshTrader: () => Promise<void>;
  signOut: () => void;
}

export const PortalCtx = createContext<Portal | null>(null);
export const usePortal = () => {
  const p = useContext(PortalCtx);
  if (!p) throw new Error('usePortal outside provider');
  return p;
};
